import { proxy } from "valtio";
import { editorState } from "../../utils/editor";
import { updateFAQs } from "../../apis/wedding/update.faqs";
import { updateGallery } from "../../apis/wedding/update.gallery";
import { updateMainContent } from "../../apis/wedding/update.main.content";
import { updateEventSchedules } from "../../apis/wedding/update.event.schedules";
import { updateBrideAndGroomShorts } from "../../apis/wedding/update.bride.and.groom.shorts";
import {
  BankAccount,
  EventSchedule,
  FAQ,
  GallerySection,
  PaymentLink,
  Template,
  Wedding,
} from "../../types/wedding";
import { updateBankAccountsAndPaymentLinks } from "../../apis/wedding/update.bank.accounts.and.payment.links";
import { updateTemplate } from "../../apis/wedding/update.template";
import { ClientStorage, ClientStorageItem } from "../../utils/clientstorage";

export const ubxdidUpdateDebounceToken = proxy({ value: 0 });

export const videoThumbnailURLBuilder = (uid: string): string => {
  const videoThumbnailURL = `https://customer-cotlm04ai8gx1o8i.cloudflarestream.com/${uid}/thumbnails/thumbnail.jpg`;
  return videoThumbnailURL;
};

type UpdateHashtagAndStuffDTO = {
  onSuccess: (wedding: Wedding) => void;
  onError: (errMessage?: string) => void;
};
export const updateHashtagAndStuff = ({
  onSuccess,
  onError,
}: UpdateHashtagAndStuffDTO) => {
  const {
    date,
    hashtag,
    coupleImage,
    coupleLoveStory,
    useHashtagAsHeaderText,
    logo,
    shouldDisplayLogo,
  } = editorState.mainContent;

  const XAccountHash =
    ClientStorage.fetch(ClientStorageItem.XAccountHash) || "";

  updateMainContent({
    headers: {
      "X-Account-Hash": XAccountHash || "",
    },
    body: {
      date: date?.toISOString?.() as any,
      hashtag: hashtag,
      coupleImage,
      coupleLoveStory,
      useHashtagAsHeaderText,
      logo,
      shouldDisplayLogo,
    },
    onCompleted({ data }) {
      onSuccess(data);
    },
    onError(err) {
      onError(err);
    },
  });
};

type UpdateYourLoveStoryDTO = {
  onSuccess: (wedding: Wedding) => void;
  onError: (errMessage?: string) => void;
};
export const updateYourLoveStory = ({
  onSuccess,
  onError,
}: UpdateYourLoveStoryDTO) => {
  const { brideImage, brideShortWords, groomImage, groomShortWords } =
    editorState.brideAndGroomShorts;
  const XAccountHash =
    ClientStorage.fetch(ClientStorageItem.XAccountHash) || "";

  updateBrideAndGroomShorts({
    headers: {
      "X-Account-Hash": XAccountHash,
    },
    body: {
      brideImage,
      brideShortWords,
      groomImage,
      groomShortWords,
    },
    onCompleted({ data }) {
      onSuccess(data);
    },
    onError(err) {
      onError(err);
    },
  });
};

type UpdateEventScheduleDTO = {
  onSuccess: (wedding: Wedding) => void;
  onError: (errMessage?: string) => void;
  eventSchedules: EventSchedule[];
};
export const updateWeddingEventSchedules = ({
  onSuccess,
  onError,
  eventSchedules,
}: UpdateEventScheduleDTO) => {
  const XAccountHash =
    ClientStorage.fetch(ClientStorageItem.XAccountHash) || "";
  updateEventSchedules({
    headers: {
      "X-Account-Hash": XAccountHash,
    },
    body: {
      eventSchedules: eventSchedules.map((sched) => {
        const { date } = sched;
        const nd = new Date(date);
        // console.log({ date, eventType });
        return {
          ...sched,
          date: nd?.toISOString?.() as any,
        };
      }),
    },
    onCompleted({ data }) {
      onSuccess(data);
    },
    onError(err) {
      onError(err);
    },
  });
};

type UpdateWeddingGalleryDTO = {
  onSuccess: (wedding: Wedding) => void;
  onError: (errMessage?: string) => void;
  gallery: GallerySection[];
};
export const updateWeddingGallery = ({
  onSuccess,
  onError,
  gallery,
}: UpdateWeddingGalleryDTO) => {
  const XAccountHash =
    ClientStorage.fetch(ClientStorageItem.XAccountHash) || "";
  updateGallery({
    headers: {
      "X-Account-Hash": XAccountHash,
    },
    body: {
      gallery,
    },
    onCompleted({ data }) {
      onSuccess(data);
    },
    onError(err) {
      onError(err);
    },
  });
};

type UpdateWeddingBankAccountsAndPaymentLinksDTO = {
  onSuccess: (wedding: Wedding) => void;
  onError: (errMessage?: string) => void;
  bankAccounts: BankAccount[];
  paymentLinks: PaymentLink[];
};
export const updateWeddingBankAccountsAndPaymentLinks = ({
  onSuccess,
  onError,
  bankAccounts,
  paymentLinks,
}: UpdateWeddingBankAccountsAndPaymentLinksDTO) => {
  const XAccountHash =
    ClientStorage.fetch(ClientStorageItem.XAccountHash) || "";
  updateBankAccountsAndPaymentLinks({
    headers: {
      "X-Account-Hash": XAccountHash,
    },
    body: {
      bankAccounts: bankAccounts,
      paymentLinks: paymentLinks,
    },
    onCompleted({ data }) {
      onSuccess(data);
    },
    onError(err) {
      onError(err);
    },
  });
};

type UpdateWeddingFAQs = {
  onSuccess: (wedding: Wedding) => void;
  onError: (errMessage?: string) => void;
  faqs: FAQ[];
};
export const updateWeddingFAQs = ({
  onSuccess,
  onError,
  faqs,
}: UpdateWeddingFAQs) => {
  const XAccountHash =
    ClientStorage.fetch(ClientStorageItem.XAccountHash) || "";
  updateFAQs({
    headers: {
      "X-Account-Hash": XAccountHash,
    },
    body: {
      faqs,
    },
    onCompleted({ data }) {
      onSuccess(data);
    },
    onError(err) {
      onError(err);
    },
  });
};

type UpdateWebsiteTemplate = {
  onSuccess: (wedding: Wedding) => void;
  onError: (errMessage?: string) => void;
  template: Template;
};
export const updateWebsiteTemplate = ({
  onSuccess,
  onError,
  template,
}: UpdateWebsiteTemplate) => {
  const XAccountHash =
    ClientStorage.fetch(ClientStorageItem.XAccountHash) || "";
  updateTemplate({
    headers: {
      "X-Account-Hash": XAccountHash,
    },
    body: {
      template,
    },
    onCompleted({ data }) {
      onSuccess(data);
    },
    onError(err) {
      onError(err);
    },
  });
};
